import React from 'react';
import { useCustomComponent } from '@/hooks';

export interface FloatingMessageContainerProps {
  children: React.ReactNode;
  onClick?: () => void;
}

const ContainerComponent: React.FC<FloatingMessageContainerProps> = ({
  children,
  onClick,
}) => {
  return (
    <div className="peptalk-floating-message" onClick={onClick}>
      {children}
    </div>
  );
};

export const Container: React.FC<FloatingMessageContainerProps> = (
  props: FloatingMessageContainerProps
) => {
  const Component = useCustomComponent({
    componentName: 'FloatingMessageContainer',
    Component: ContainerComponent,
  });

  return <Component {...props} />;
};
